import script from "./header-info.vue?vue&type=script&lang=ts&setup=true"
export * from "./header-info.vue?vue&type=script&lang=ts&setup=true"

import "./header-info.vue?vue&type=style&index=0&id=7975416e&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7975416e"]])

export default __exports__